import { 
  GET_ADMIN_DASHBOARD_STICKY_COLUMNS, 
  GET_ADMIN_DASHBOARD_STICKY_COLUMNS_ERROR, 
  GET_ADMIN_DASHBOARD_STICKY_COLUMNS_SUCCESS,
  UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS,
  UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS_ERROR,
  UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS_SUCCESS
} from "./actionTypes"

// FOR GET ADMIN DASHBOARD STICKY COLUMNS
export const getAdminDashboardStickyColumns = () => {
  return {
    type: GET_ADMIN_DASHBOARD_STICKY_COLUMNS,
  }
}

export const getAdminDashboardStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_ADMIN_DASHBOARD_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getAdminDashboardStickyColumnsError = error => {
  return {
    type: GET_ADMIN_DASHBOARD_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

// FOR UPDATE ADMIN DASHBOARD STICKY COLUMNS
export const updateAdminDashboardStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateAdminDashboardStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateAdminDashboardStickyColumnsError = error => {
  return {
    type: UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}